import Header from 'components/Header/Header';
import React from 'react';
import ShopResultListHeader from 'components/ShopResultListHeader/ShopResultListHeader';
import Aside from 'components/Aside/Aside';
import ShopResultList from 'components/ShopResultList/ShopResultList';
import Footer from 'components/Footer/Footer';
import { GetResultPageComponentsProps } from 'models/GetResultPageComponentsProps';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import MobileAppDownloadBanner from 'components/MobileAppDownloadBanner/MobileAppDownloadBanner';

export const getResultPageComponents = ({
  activeFilters,
  onParameterChange,
  category,
  keyword,
  keywords,
  account,
  setMobileMenuOpen,
  mobileMenuOpen,
  metadata,
  setModalVisible,
  categoryList,
  shops,
  calledByAccountPage = false
}: GetResultPageComponentsProps) => {
  const showFooter = !activeFilters.embed;

  return (
    <>
      <Header
        activeFilters={activeFilters}
        onParameterChange={onParameterChange}
        category={category ? category.name : undefined}
        keyword={keyword}
        account={account}
        hideNavigation={!!activeFilters.embed}
        mobileMenuHandler={{
          setMobileMenuOpen: setMobileMenuOpen,
          mobileMenuOpen: mobileMenuOpen
        }}
      />
      {metadata.totalShopCount > 0 ? (
        <>
          <ShopResultListHeader
            activeFilters={activeFilters}
            category={category ? category.name : undefined}
            keyword={keyword}
            numberResults={metadata.totalShopCount}
            onParameterChange={onParameterChange}
            setModalVisible={setModalVisible}
          />
          {!calledByAccountPage &&
            !!categoryList &&
            categoryList.length > 0 && (
              <Aside
                categoryList={categoryList}
                activeFilters={activeFilters}
                keyword={keyword}
              />
            )}
          <ShopResultList
            activeFilters={activeFilters}
            shops={shops}
            pageCount={metadata.totalPageCount}
            keywords={keywords}
          />
        </>
      ) : (
        /* istanbul ignore next: our visual regression tests are enough to test this part */
        <NoResultsFound
          activeFilters={activeFilters}
          categoryList={categoryList}
        />
      )}
      {showFooter && <Footer />}
      {showFooter && (
        <MobileAppDownloadBanner embedActive={!!activeFilters.embed} />
      )}
    </>
  );
};
